import { Component, Input } from '@angular/core';
import { NotificationType } from 'carbon-components-angular/notification/notification-content.interface';

@Component({
	selector: 'notification',
	templateUrl: './notification.component.html',
	styleUrls: ['./notification.component.css']
})
export class NotificationComponent {

	@Input() notificationTitle = '';
	@Input() notificationSubtitle = '';
	@Input() showNotification = false;
	@Input() notificationType = 'success' as NotificationType;

}
